export default {"src":"/polygon/_next/static/media/partner_6.b274cd6c.svg","height":121,"width":180};